import en from './en.json';
import cn from './cn.json'
import tw from './tw.json'
import jp from './jp.json'

export default { en, cn, tw, jp }